import GoogleCalendarPanel from './GoogleCalendarPanel'

export default GoogleCalendarPanel
